import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';

const toolName = 'find-unused-styles' as const;

export const findUnusedStylesArgsSchema = z.object({});

export type FindUnusedStylesArgs = z.infer<typeof findUnusedStylesArgsSchema>;

export const findUnusedStylesTool = defineToolRegistryManifest({
  id: toolName,
  type: 'designer',
  featureGate: FEATURE_FLAGS.AIA_STYLE_CLEANUP_ARTIFACTS,
  permission: [{resource: 'SiteStyleBlock', action: 'read'}],
  prettyName: 'Find unused styles',
  prettyStatus: {
    executed: 'Finished searching',
    executing: 'Finding unused styles',
    failed: 'Failed to find unused styles',
  },
  confirmBeforeExecuting: false,
  timeout: 30000,
  llmTool: {
    name: toolName,
    description: dedent`
      Lists CSS classes on the current site that no element uses. Use when the user asks to find, list, audit, or clean up unused styles or unused CSS classes. Do not call when the user asks for styles applied to a specific selector (use search-styles) or for the full list of selectors on the site (use get-all-selectors-from-site). This tool only finds unused styles; it does not delete them.
    `,
    inputSchema: findUnusedStylesArgsSchema,
  },
});
